import { useState } from "react";
import PlayNextVideoIcon from "./playNextVideoIcon";
import { changeVideoUrl, conditions } from "helpers";
import { ConditionName } from "interfaces";
import dynamic from "next/dynamic";

const ControllbarTooltip = dynamic(() => import("../../mainComponent/footer/controllbar/controllbarTooltip"));

const PlayNextVideo = () => {
    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    return (
        <div className="pl-relative pl-flex pl-items-center">
            <PlayNextVideoIcon
                onClick={() => (window.location.href = changeVideoUrl())}
                onMouseOver={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(true)}
                onMouseLeave={() => !conditions(ConditionName.isTouchScreen) && setShowTooltip(false)}
            />
            {showTooltip && <ControllbarTooltip title={"پخش ویدیوی بعدی (n)"} className="pl-right-[-70px]" />}
        </div>
    );
};

export default PlayNextVideo;
